import SpokeRoundedIcon from "@mui/icons-material/SpokeRounded";
import { Skeleton } from "@mui/material";

import "./styles.css";
import { VerifiedRounded } from "@mui/icons-material";


export function CommunityBanner({ banner, small = false, size = 48, className = "" }) {

  size = small ? 32 : size;

  return (
    <div
      className={"community-banner-block " + (small && "banner-small") + " " + className  }
      style={{
        width: `${size}px`,
        height: `${size}px`,
        maxWidth: `${size}px`,
      }}
    >
      {banner ? <img src={banner} /> : <SpokeRoundedIcon />}
    </div>
  );
}

export function UserAvatar({
  user,
  size = 48,
  small = false,
  loading = false,
  className = "",
  style = {},
  displayName = false,
  displayNickname = false
}) {
  if (loading) {
    return (
      <Skeleton
        variant="circular"
        width={size}
        height={size}
        className={className}
        style={style}
      />
    );
  }



  function Avatar() {
    const cleanAvatarUrl = user.avatar

    return (
      <div
        className={"user-banner " + (small && " banner-small ")}
        style={{
          width: size,
          height: size,
          maxWidth: size,
          maxHeight: size
        }}
      >
        {cleanAvatarUrl ? (
          <img src={cleanAvatarUrl} />
        ) : (
          <span className="bold">
            {user?.username
              ?.split(" ")
              .slice(0, 2)
              .map((c) => c.split('')[0])}
          </span>
        )}
      </div>
    )
  }

  if (!user) return null;

  return (
    <div className={"user-card-container " + className} style={style}>
      <Avatar />
      {
        displayName && (
          <div className="user-card-name-container">
            {
              displayName && (
                <span className="user-card-name">
                  {user?.username}
                  {user?.verified ? <VerifiedRounded
                    style={{ marginLeft: '2px', color: 'var(--primary-6)' }}
                    className="verified-icon"
                    
                  /> : null}
                </span>
              )
            }
            {
              displayNickname && user?.nickname && (
                <span className="user-card-nickname">
                  @{user?.nickname}
                </span>
              )
            }
          </div>
        )
      }

    </div>
  );
}
